
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';

interface Props {
  article: ArticleData;
}

interface Data {
  title: string | null;
  ttsUrl: string | null;
}

interface Computed {
  showListenButton: boolean;
}

interface Methods {
  setFontSize: () => void;
  handleShowPlayer: () => void;
  getTtsUrl(): string | null;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      title: typeof window !== 'undefined' ? window.document.title.replace('"', '') : null,
      ttsUrl: null,
    };
  },
  computed: {
    showListenButton() {
      return this.$channelConfig('page').article.component.info.listenIconShow && this.article.content.paywall.enabled && this.ttsUrl !== null;
    },
  },
  async mounted() {
    // Check if has TTS file only for paid articles
    if (this.article.content.paywall.enabled) {
      await this.$nextTick();

      if (this.$store.state.piano.isScriptInited) {
        this.ttsUrl = this.getTtsUrl() ?? null;
      } else if (!this.$store.state.piano.isScriptInited) {
        this.$store.watch(
          (state) => state.piano.isScriptInited,
          async () => {
            this.ttsUrl = this.getTtsUrl() ?? null;
          }
        );
      }
    }
  },
  methods: {
    setFontSize() {
      this.$emit('set-font-size');
    },
    handleShowPlayer() {
      this.$emit('handle-show-player');
    },
    getTtsUrl() {
      if (this.$store.state.piano.access.channelAccess && this.article.ttsSettings.textToSpeech !== '') {
        return this.article.ttsSettings.textToSpeech;
      }

      if (this.article.ttsSettings.textToSpeechTeaser !== '') {
        return this.article.ttsSettings.textToSpeechTeaser;
      }

      return null;
    },
  },
});
